export class ExaminationPreferenceService {
  static async updateShowTranscript(showTranscript) {
    try {
      const response = await fetch('/examination_preference', {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({
          examination_preference: {
            show_transcript: showTranscript
          }
        })
      })

      if (!response.ok) {
        const errorData = await response.json()
        throw new Error(errorData.error || 'サーバーエラーが発生しました')
      }

      return await response.json()
    } catch (error) {
      console.error('ExaminationPreference更新エラー:', error)
      throw error
    }
  }

  static async updateSoapPromptTemplate(templateId) {
    try {
      const response = await fetch('/examination_preference', {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({
          examination_preference: {
            soap_prompt_template_id: templateId
          }
        })
      })

      if (!response.ok) {
        const errorData = await response.json()
        throw new Error(errorData.error || 'サーバーエラーが発生しました')
      }

      return await response.json()
    } catch (error) {
      console.error('SOAPプロンプト更新エラー:', error)
      throw error
    }
  }
}